import { useUser, useGlobalStore } from '@haohan/clw-store'
import { getCompChildren } from '@haohan/clw-utils'
import { ref } from 'vue'
import { memoize } from 'lodash-es'

/**
 * 将树结构转换成扁平数组
 * 限于云视域组件结构
 */
function tree2Array4CompFn(tree: any[]) {
  const stack = [...tree.reverse()]
  const result = []
  while (stack.length) {
    const node = stack.pop()
    if (node.prop?.permissionCtrl) {
      result.push(node)
    }
    const children = getCompChildren(node)
    if (children?.length) {
      for (const childObj of children.reverse()) {
        stack.push(...childObj.list.slice().reverse())
      }
    }
  }
  return result
}

function getChild(list: any[], pid: any) {
  return list.filter((item) => item.parentId === pid)
}

/**
 * 权限控制 hook
 * 公共页面用权限的name，拖拽页面用id
 */
export function usePermissionHook() {
  const userStore = useUser()
  const generalPermission = userStore.generalPermission
  // const clwPermission = userStore.clwPermission
  const hasPermissionFn = memoize((value: string | string[], type = 'clw') => {
    console.log('v-permission', value, type)
    if (!value) {
      return true
    }
    // 将值转化为数组方式
    let _value = value
    if (value && !(value instanceof Array)) {
      _value = [value]
    }
    // 判断是否包含传入的权限
    switch (type) {
      case 'GENERAL': {
        const hasPermission = generalPermission?.some((p: any) => {
          return _value.includes(p.permission_path)
        })
        return hasPermission
      }
      // default: {
      //   const hasPermission = clwPermission?.some((p: any) => {
      //     return _value.includes(p.name)
      //   })
      //   return hasPermission
      // }
    }
  })

  return {
    tree2Array4CompFn,
    hasPermissionFn,
    generalPermission
  }
}

export function useCompPermissionHook(cid: any) {
  const userStore = useUser()
  const global = useGlobalStore()
  const userPermissionWithoutGeneral = userStore.clwPermission
  const globalPermissionWithoutGeneral = global.permissionArr.filter(
    (p: any) => p.type !== 'GENERAL'
  )

  const pmCtrl = ref(false) // 是否有控制权限
  const pmShow = ref(false) // 是否有显示权限
  const pmPermission = ref<any[]>([]) // 权限列表
  function genCompPInfo(cid: any) {
    const globalItem = globalPermissionWithoutGeneral.find((p: any) => p.name === cid)
    if (globalItem) {
      pmCtrl.value = true
      const item = userPermissionWithoutGeneral.find((p: any) => p.name === cid)
      if (item) {
        pmShow.value = true
        pmPermission.value = getChild(userPermissionWithoutGeneral, item.id)?.map(
          (p: any) => p.title
        )
      }
    }
  }
  genCompPInfo(cid)

  return {
    pmCtrl,
    pmShow,
    pmPermission
  }
}
